//
//
//
//
//
//
//

import FieldMixin from './FieldMixin';

export default {
	mixins: [FieldMixin],
}
